import { render, staticRenderFns } from "./StorySection.vue?vue&type=template&id=b5dd1ae2&scoped=true"
import script from "./StorySection.vue?vue&type=script&lang=js"
export * from "./StorySection.vue?vue&type=script&lang=js"
import style0 from "./StorySection.vue?vue&type=style&index=0&id=b5dd1ae2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5dd1ae2",
  null
  
)

export default component.exports